import {
	QSR_PRODUCT_TYPES_FETCH_REQUEST,
	QSR_PRODUCT_TYPES_FETCH_FAILURE,
	QSR_PRODUCT_TYPES_FETCH_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case QSR_PRODUCT_TYPES_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
			};

		case QSR_PRODUCT_TYPES_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case QSR_PRODUCT_TYPES_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/QSRProductTypes.js